import { makeStyles } from "@material-ui/core/styles";

export const useFileActionsStyles = makeStyles(() => ({
  rightAligned: {
    textAlign: "right",
  },
}));
